<template>
  <MountingPortal
    mount-to="#kd-ehdokasgalleria-modal-mount"
    append
  >
    <div
      :class="[
        'modal',
        value == true ? 'modal--open' : null,
      ]"
      class="modal"
      @click="bgClick"
    >
      <div
        :class="wrapClass"
      >
        <div
          class="modal__box"
          tabindex="0"
          ref="box"
          @click.stop
        >
          <div
            v-if="!loading"
            class="
              modal__header
              p-single
            "
          >
            <div
              v-if="backButton"
              class="modal__header-left"
            >
              <button
                @click="$emit('back')"
                class="modal__button modal__button--back"
              >
                <span class="sr-only">
                  {{ $t('buttons.back.label') }}
                </span>
                <font-awesome-icon
                  icon="angle-left"
                />
              </button>
            </div>
            <div class="modal__header-center p-single">
              <h2
                v-if="title"
                class="modal__title"
              >
                {{ title }}
              </h2>
              <p
                v-if="summary"
                class="modal__summary"
              >
                {{ summary }}
              </p>
            </div>
            <div
              v-if="closeButton"
              class="modal__header-right"
            >
              <button
                class="modal__button modal__button--close"
                @click="close"
                ref="closeButton"
              >
                <span class="sr-only">
                  {{ $t('buttons.closeWindow.label') }}
                </span>
                <font-awesome-icon
                  icon="times"
                />
              </button>
            </div>
          </div>
          <div
            class="
              modal__content
            "
            tabindex="0"
            ref="content"
          >
            <Spinner
              v-if="loading"
              class="p-double"
              :text="loadingText"
            />
            <slot v-else />
          </div>
          <div
            v-if="!loading && (this.$slots['footer'] || this.$slots['footer-right'])"
            class="modal__footer p-single"
          >
            <div
              v-if="!!$slots['footer']"
              class="modal__footer-left p-single"
            >
              <slot name="footer" />
            </div>
            <div
              v-if="!!$slots['footer-right']"
              class="modal__footer-right p-single"
            >
              <slot name="footer-right" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </MountingPortal>
</template>

<script>

export default {
  name: 'Modal',
  data: () => ({
    tabIndex: 1,
    bgClickActive: false,
    resizeTimeout: null,
  }),
  props: {
    value: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    loadingText: {
      type: [String, Number],
      required: false,
      default () {
        return null
      },
    },
    size: {
      type: String,
      required: false,
      default () {
        return 'sm'
      },
      validator: function (val) {
        return ['sm', 'md', 'lg', 'full'].indexOf(val) !== -1
      },
    },
    title: {
      type: [String, undefined],
      required: false,
      default () {
        return undefined
      },
    },
    summary: {
      type: [String, undefined],
      required: false,
      default () {
        return undefined
      },
    },
    closeOnBgClick: {
      type: Boolean,
      required: false,
      default () {
        return true
      },
    },
    closeButton: {
      type: Boolean,
      required: false,
      default () {
        return true
      },
    },
    closeOnEsc: {
      type: Boolean,
      required: false,
      default () {
        return true
      },
    },
    backButton: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
  },
  computed: {
    wrapClass () {
      return [
        'modal__wrap',
        'modal__wrap--' + this.size,
        this.value == true ? 'modal__wrap--open' : null,
        this.bgClickActive ? 'modal__wrap--shake' : null,
      ]
    },
  },
  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('close')
    },

    focusOnBox () {
      setTimeout(() => {
        if (typeof this.$refs.box !== 'undefined') {
          this.$refs.box.scrollTop = 0
          this.$refs.box.focus()
        }
      }, 200)
    },

    handleKeyDown (e) {
      if (this.closeOnEsc && e.key == 'Escape') {
        this.close()
      }
    },

    bgClick () {
      if (!this.closeOnBgClick) {
        // Shake modal box
        this.bgClickActive = true

        setTimeout(() => {
          this.bgClickActive = false
        }, 200)

        return
      }

      this.close()
    },
  },
  watch: {
    value (val) {
      if (val == true) {
        // Add event listeners
        document.addEventListener('keydown', this.handleKeyDown)

        // Emit event
        this.$emit('open')

        // Prevent window scrolling
        document.documentElement.style.overflowY = 'hidden'

        // Focus to modal box
        this.focusOnBox()
      } else {
        // Remove event listeners
        document.removeEventListener('keydown', this.handleKeyDown)

        // Enable window scrolling
        document.documentElement.style.overflowY = null
      }
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
